/*
 * File: LinkingForm.tsx
 * Project: a-a
 * File Created: Friday, 10th October 2025 6:10:42 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 10th December 2025 8:30:08 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useRef, useState } from 'react';
import CustomModal from '../../../../../components/shared/CustomModal/CustomModal';
import CustomCard from '../../../../../components/shared/CustomCard/CustomCard';
import { Box, Checkbox, Typography } from '@mui/material';
import zeplinColor from '../../../../../theme/Color';
import CustomButton from '../../../../../components/shared/CustomButton/CustomButton';
import CustomSearch from '../../../../../components/shared/CustomSearch/CustomSearch';
import { ReactComponent as SlackIcon } from '../../../../../assets/slack-icon.svg';
import { ReactComponent as Captiv8Icon } from '../../../../../assets/captiv8-link-icon.svg';
import CustomAutocomplete from '../../../../../components/shared/CustomAutocomplete/CustomAutocomplete';
import { ClientService } from '../../../../../service/client.service';
import { Link, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { SlackService } from '../../../../../service/slack.service';
import CustomStepper from '../../../../../components/shared/CustomStepper/CustomStepper';
import styles from './LinkingForm.module.css';
import { HuddleClientService } from '../../../../../service/huddle-client.service';

const LinkingForm = ({
  modalOpen,
  clientId,
  setLinkModal,
  client,
  getAllClient,
  platform_created,
}: {
  modalOpen: boolean;
  clientId: string;
  setLinkModal: React.Dispatch<React.SetStateAction<boolean>>;
  client?: any;
  getAllClient?: () => void;
  platform_created?: string;
}) => {
  const location = useLocation();
  const isSlackConnected = sessionStorage.getItem('isSlackConnected') === 'true';
  const [step, setStep] = useState<number>(isSlackConnected ? 0 : -1);
  const [loading, setLoading] = useState(false);
  const [slackLoading, setSlackLoading] = useState(false);
  const [connectLoading, setConnectLoading] = useState(false);
  const [captiv8, setCaptiv8] = useState([]);
  const [slackChannels, setSlackChannels] = useState([]);
  const [slackAllChannels, setSlackAllChannels] = useState([]);
  const [error, setError] = useState(false);
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});
  const [selectedItems, setSelectedItems] = useState<{
    slack: string[];
    captiv8: any[];
  }>({
    slack: client?.slackChannelId ? client?.slackChannelId?.split(',') : [],
    captiv8: client?.captiv8Id ? [client?.captiv8Id] : [],
  });
  console.log({ selectedItems });
  const wait = useRef<any>();
  const handleSelection = (item: any, type: string | boolean) => {
    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };

  const handleLink = async () => {
    try {
      // console.log('pathyname', location?.pathname?.split('/'));
      setConnectLoading(true);
      const res =
        platform_created === 'huddle' || location?.pathname.includes('huddle')
          ? await HuddleClientService.editHuddleClient(
              {
                GD_Slack_Channel_Id__c: selectedItems?.slack?.join(','),
                Captive8_Creator_Id__c: selectedItems?.captiv8[0]?.Id
                  ? selectedItems?.captiv8[0]?.Id
                  : '',
              },
              clientId,
            )
          : await ClientService.editClient(
              {
                GD_Slack_Channel_Id__c: selectedItems?.slack?.join(','),
                Captive8_Creator_Id__c: selectedItems?.captiv8[0]?.Id
                  ? selectedItems?.captiv8[0]?.Id
                  : '',
              },
              clientId,
            );
      console.log(res);
      setLinkModal(false);
      setSelectedItems({ slack: [], captiv8: [] });
      sessionStorage.removeItem('new-client');
      sessionStorage.removeItem('platform');
      location?.pathname?.split('/')?.length < 3 &&
        sessionStorage.setItem('link-successful', 'true');
      setStep(0);
      getAllClient && getAllClient();
    } catch (err) {
      console.log(err);
    } finally {
      setConnectLoading(false);
    }
  };
  const getCaptive8Info = async (id: string) => {
    try {
      setLoading(true);
      console.log({ id });
      const res = await ClientService.getCaptive8Info(id);
      console.log({ res });
      setSelectedItems((prev) => ({
        ...prev,
        captiv8: [
          {
            Id: client?.captiv8Id,
            Name: res?.name,
            avatar: res?.avatar,
          },
        ],
      }));
      // setSocialEngagement(res);
    } catch (err) {
      if (!client?.captive8Id) {
        // setError('Client not found in Captive8');
        setError(true);
      } else {
        // setError('Something went wrong');
        setError(true);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleNext = () => {
    if (step === -1) {
      setStep(1);
    }
    setStep((prev: number) => (prev < 1 ? prev + 1 : prev));
    console.log(client?.AccountId, step === 0, client?.captiv8Id);
    client?.AccountId && step === 0 && client?.captiv8Id && getCaptive8Info(client?.captiv8Id);
    step === 1 && handleLink();
  };
  const handlePrev = () => {
    setStep((prev: number) => (prev > 0 ? prev - 1 : prev));
  };
  const suggestionCaptiv8API = async (value: string) => {
    try {
      setLoading(true);
      const res = await ClientService.searchCaptiv8(value?.toLocaleLowerCase());
      console.log(res);
      setCaptiv8(
        res?.users?.map((val: any) => ({
          Id: val?.captiv8Id,
          Name: val?.name,
          avatar: val?.avatar,
          followers: val?.followers,
        })),
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCaptiv8Search = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    if (value) {
      const getSuggestion = setTimeout(() => suggestionCaptiv8API(value), 1000);
      wait.current = getSuggestion;
    }
  };
  const handleSkip = () => {
    setLinkModal(false);
    sessionStorage.removeItem('new-client');
    setStep(0);
    getAllClient && getAllClient();
  };
  const getSlackChannels = async () => {
    try {
      setSlackLoading(true);
      const res = await SlackService.getSlackChannels();

      setSlackChannels(res);
      setSlackAllChannels(res);
    } catch (err) {
      console.log(err);
    } finally {
      setSlackLoading(false);
    }
  };
  useEffect(() => {
    getSlackChannels();
  }, []);
  console.log(selectedItems);
  return (
    <CustomModal handleClose={() => {}} open={modalOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '16px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            position: 'relative',
            width: { xs: '400px', xl: '474px' },
            ...(isSlackConnected && {
              height: {
                xs: client?.AccountId ? '580px' : '650px',
                xl: client?.AccountId ? '740px' : '790px',
              },
            }),
            // height: '183px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between',
          }}
        >
          <>
            {(step === 0 || step === -1) && (
              <Box
                sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '16px', xl: '24px' } }}
              >
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '6px', xl: '8px' } }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '16px',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <Typography variant='responsiveHeading2' sx={{ width: '100%' }}>
                      {!client?.AccountId
                        ? 'Almost done! Let’s set up your client’s workspace'
                        : 'Manage Integrations'}
                    </Typography>
                    {!client?.AccountId ? (
                      <Typography
                        variant='responsiveButtonMedium'
                        color={zeplinColor?.Brand1}
                        sx={{
                          cursor: 'pointer',
                          width: '20%',
                          display: 'inline',
                          ml: 'auto', // Pushes Skip All to the right
                          textAlign: 'right',
                        }}
                        onClick={handleSkip}
                      >
                        Skip All
                      </Typography>
                    ) : (
                      <img
                        src={'/assets/close-icon.svg'}
                        className={styles['close-icon']}
                        alt='close'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setLinkModal(false);
                          setStep(0);
                        }}
                      />
                    )}
                  </Box>
                  {!client?.AccountId ? (
                    <Typography variant='responsiveBody3' color={zeplinColor?.Neutral9}>
                      Connect integrations to bring all updates and data in one place
                    </Typography>
                  ) : (
                    ''
                  )}
                </Box>
                <Box sx={{ width: '70%' }}>
                  <CustomStepper
                    activeStep={step}
                    setActiveStep={setStep}
                    setCompleted={setCompleted}
                    completed={completed}
                    steps={['Slack', 'Captiv8']}
                    style={{
                      width: '100%',
                      padding: { xs: '12px 16px 10px 0px', xl: '24px 16px 10px 0px' },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '12px', xl: '16px' },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: { xs: '6px', xl: '8px' },
                    }}
                  >
                    <SlackIcon className={styles.icon} />
                    <Typography variant='responsiveHeading3'>
                      {!isSlackConnected
                        ? 'Connect Slack to Get Started'
                        : 'Connect Your Slack Channels'}
                    </Typography>
                    <Typography variant='responsiveBody3' color={zeplinColor.Neutral9}>
                      {!isSlackConnected
                        ? 'Connect your Slack workspace to view and link channels with the client. This helps you receive updates, manage tasks, and collaborate directly from Huddle.'
                        : "Select the Slack channels you'd like to connect with client. This will help you receive updates, manage tasks, and collaborate directly from Huddle."}
                    </Typography>
                  </Box>
                </Box>
                {isSlackConnected ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      //   overflowY: 'scroll',
                    }}
                  >
                    <Typography variant='responsiveBody3'>
                      Available channels ({slackChannels?.length})
                    </Typography>
                    <Box
                      sx={{
                        height: { xs: '210px', xl: '300px' },
                        borderRadius: '16px',
                        border: `1px solid ${zeplinColor.Neutral5}`,
                        overflowY: 'scroll',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: '6px', xl: '8px' },
                      }}
                    >
                      <Box
                        sx={{
                          padding: '16px',
                          position: 'sticky',
                          top: 0,
                          background: zeplinColor.Neutral1,
                          zIndex: 1,
                        }}
                      >
                        <CustomSearch
                          setProjects={() => {}}
                          getProjects={(text: string) => {
                            setSlackChannels(() =>
                              slackAllChannels?.filter((channel: any) =>
                                channel?.name?.toLowerCase()?.includes(text?.toLowerCase()),
                              ),
                            );
                          }}
                        />
                      </Box>
                      {slackChannels?.length
                        ? slackChannels?.map((val: any) => (
                            <Box
                              sx={{
                                display: 'flex',
                                gap: '8px',
                                padding: { xs: '4px 16px', xl: '8px 16px' },
                                borderBottom: `1px solid ${zeplinColor.Neutral5}`,
                              }}
                              onClick={() => {
                                setSelectedItems((prev: any) =>
                                  selectedItems?.slack?.indexOf(val?.id) > -1
                                    ? {
                                        ...prev,
                                        slack: prev.slack.filter(
                                          (slackPrev: string) => slackPrev !== val?.id,
                                        ),
                                      }
                                    : {
                                        ...prev,
                                        slack: [...prev.slack, val?.id],
                                      },
                                );
                              }}
                            >
                              <Checkbox
                                disabled={false}
                                checked={selectedItems?.slack?.indexOf(val?.id) > -1}
                                sx={{
                                  borderRadius: '4px',
                                  padding: '0 8px 0 0',
                                  '&.Mui-checked': {
                                    color: zeplinColor.BasicBlack,
                                  },
                                }}
                              />
                              <Box
                                sx={{
                                  width: '32px',
                                  height: '32px',
                                  backgroundColor: zeplinColor.Neutral4,
                                  borderRadius: '8px',
                                  // padding: '10px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  // borderRadius: '8px',
                                }}
                              >
                                <img
                                  src={
                                    val?.is_private
                                      ? '/assets/private-slack.svg'
                                      : '/assets/public-slack.svg'
                                  }
                                  style={{ width: '14px', height: '14px' }}
                                />
                              </Box>
                              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='responsiveHeading4'>{val?.name}</Typography>
                                <Typography variant='responsiveBody3' color={zeplinColor?.Neutral8}>
                                  {val?.num_members} member{val?.num_members > 1 ? 's' : ''}
                                </Typography>
                              </Box>
                            </Box>
                          ))
                        : slackLoading
                        ? 'Slack channels loading....'
                        : 'no channels found'}
                    </Box>
                  </Box>
                ) : (
                  <></>
                )}
              </Box>
            )}
            {step === 1 && (
              <Box
                sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '16px', xl: '24px' } }}
              >
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '6px', xl: '8px' } }}
                >
                  <Box sx={{ display: 'flex', gap: '16px', justifyContent: 'space-between' }}>
                    <Typography variant='responsiveHeading2'>
                      {!client?.AccountId
                        ? 'Almost done! Let’s set up your client’s workspace'
                        : 'Manage Integrations'}
                    </Typography>
                    {!client?.AccountId ? (
                      <Typography
                        variant='responsiveButtonMedium'
                        color={zeplinColor?.Brand1}
                        sx={{ cursor: 'pointer', width: '20%', textAlign: 'right' }}
                        onClick={handleSkip}
                      >
                        Skip All
                      </Typography>
                    ) : (
                      <img
                        src={'/assets/close-icon.svg'}
                        className={styles['close-icon']}
                        alt='close'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setLinkModal(false);
                          setStep(0);
                        }}
                      />
                    )}
                  </Box>
                  {!client?.AccountId ? (
                    <Typography variant='responsiveBody3' color={zeplinColor?.Neutral9}>
                      Connect integrations to bring all updates and data in one place
                    </Typography>
                  ) : (
                    ''
                  )}
                </Box>
                <Box sx={{ width: '70%' }}>
                  <CustomStepper
                    activeStep={step}
                    setActiveStep={setStep}
                    setCompleted={setCompleted}
                    completed={completed}
                    steps={['Slack', 'Captiv8']}
                    style={{
                      width: '100%',
                      padding: { xs: '12px 16px 10px 0px', xl: '24px 16px 10px 0px' },
                    }}
                  />
                </Box>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '12px', xl: '16px' } }}
                >
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '6px', xl: '8px' } }}
                  >
                    <Captiv8Icon className={styles.captiv8Icon} />
                    <Typography variant='responsiveHeading3'>
                      Connect a Client from Captiv8
                    </Typography>
                    <Typography variant='responsiveBody3' color={zeplinColor.Neutral9}>
                      Use the search bar to find your client in Captiv8 and connect them to access
                      insights directly in Huddle.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    height: { xs: '260px', xl: '350px' },
                    //   overflowY: 'scroll',
                  }}
                >
                  <Box
                    sx={
                      {
                        //   borderRadius: '16px',
                        //   border: `1px solid ${zeplinColor.Neutral5}`,
                        //   overflowY: 'scroll',
                        //   position: 'relative',
                        //   display: 'flex',
                        //   flexDirection: 'column',
                        //   gap: '8px',
                      }
                    }
                  >
                    <CustomAutocomplete
                      loading={loading}
                      chip={true}
                      searchIcon='/assets/Search.svg'
                      required={false}
                      options={captiv8 || []}
                      getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
                      label={'Search client'}
                      handleDeleteItems={() => {
                        handleSelection([], 'captiv8');
                      }}
                      selectedItems={[]}
                      handleSelection={(value) => {
                        handleSelection(value, 'captiv8');
                      }}
                      value={selectedItems?.captiv8[0]}
                      handleFilter={handleCaptiv8Search}
                      placeholder='Search client'
                      currentLength={captiv8?.length}
                      totalLength={captiv8?.length}
                      next={() => {}}
                      multiple={false}
                      inputBorder={50}
                    />
                    {/* <CustomSearch
                      setProjects={() => {}}
                      getProjects={(text: string) => {
                        handleCaptiv8Search(text);
                      }}
                    /> */}
                  </Box>
                </Box>
              </Box>
            )}
            <Box
              sx={{
                width: '100%',
                position: 'sticky',
                bottom: '0px',
                margin: 'auto',
                zIndex: '100',
                padding: '24px 0px 0px 0px',
                flex: 1,
                display: 'flex',
                gap: '24px',
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              {step > 0 && (
                <CustomButton
                  disabled={false}
                  onClick={() => {
                    handlePrev();
                  }}
                  variant='outlined'
                  color={'customSecondary'}
                  style={{
                    borderRadius: '14px',
                    height: 48,

                    width: '100%',
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                    flex: 1,
                  }}
                  textStyle={{
                    color: zeplinColor.BasicBlack,
                  }}
                  text={'Back'}
                  // tabindex={4}
                />
              )}
              {!isSlackConnected && (step === 0 || step === -1) ? (
                <Link
                  to={`https://slack.com/oauth/v2/authorize?${queryString.stringify({
                    client_id: '1547360932450.9088642262659',
                    // scope: 'channels:manage,channels:read,channels:history,groups:read,groups:write,groups:history,im:read,im:history,mpim:read,mpim:history',
                    user_scope:
                      'users:read,channels:read,channels:history,groups:read,groups:write,chat:write,groups:history,im:read,im:history,mpim:read,mpim:history',
                    redirect_uri: `${process.env.REACT_APP_REDIRECT}`,
                  })}`}
                  // target='_blank'
                  // rel='noopener noreferrer'
                  style={{ color: zeplinColor.Neutral1, textDecoration: 'none', width: '100%' }}
                  onClick={() => {
                    // Set session storage flag before redirecting
                    sessionStorage.setItem('slackConnecting', 'true');
                    // Optionally notify the parent component
                    // if (setShowSlackConnect) {
                    //   setShowSlackConnect(false);
                    // }
                  }}
                >
                  <CustomButton
                    disabled={false}
                    onClick={() => {
                      //   sessionStorage.setItem('sf_redirect', 'Activity');
                      sessionStorage.setItem('sf_path', location?.pathname);
                    }}
                    variant='contained'
                    color={'primary'}
                    buttonVariant='buttonSmall'
                    style={{
                      width: '100%',
                      //   flex: 4,
                      borderRadius: '14px',
                      height: 48,
                      padding: '14px 16px',
                      '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                    }}
                    textStyle={{ color: zeplinColor.Neutral1 }}
                    text={'Connect to Slack'}

                    // tabindex={4}
                  />
                </Link>
              ) : (
                <CustomButton
                  disabled={
                    connectLoading ||
                    (step === 1 &&
                      !selectedItems?.captiv8?.length &&
                      !selectedItems?.slack?.length) ||
                    (!isSlackConnected && !selectedItems?.captiv8?.length)
                      ? true
                      : false
                  }
                  onClick={() => {
                    handleNext();
                  }}
                  variant='contained'
                  // buttonVariant={'responsiveButtonMedium'}
                  color={'primary'}
                  style={{
                    width: '100%',
                    flex: 4,
                    borderRadius: '14px',
                    height: 48,
                    padding: '14px 16px',
                    '&.Mui-focusVisible': {
                      backgroundColor: '#333CAA',
                    },
                  }}
                  textStyle={{ color: zeplinColor.Neutral1, fontSize: { xs: '14px', xl: '16px' } }}
                  text={connectLoading ? 'Connecting...' : step === 1 ? 'Connect' : 'Next'}
                  // tabindex={4}
                />
              )}
              {(step === 0 || step === -1) && !isSlackConnected && (
                <CustomButton
                  disabled={false}
                  onClick={() => {
                    handleNext();
                  }}
                  variant='outlined'
                  color={'customSecondary'}
                  style={{
                    borderRadius: '14px',
                    height: 48,

                    width: '100%',
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                    flex: 1,
                  }}
                  textStyle={{
                    color: zeplinColor.BasicBlack,
                  }}
                  text={'Next'}
                  // tabindex={4}
                />
              )}
            </Box>
          </>
        </CustomCard>
        {/* {loading ? <CustomLoader /> : ''} */}
      </Box>
    </CustomModal>
  );
};

export default LinkingForm;
